import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  class: "app-main",
  id: "main"
}
const _hoisted_3 = { class: "side" }
const _hoisted_4 = { class: "content" }

import {onUpdated} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutView',
  setup(__props) {


onUpdated(() => {
  document.getElementsByClassName('content').item(0)?.scrollTo(0, 0)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view, { name: "header" })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_view, { name: "side" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_view)
      ])
    ])
  ], 64))
}
}

})